import React from 'react';
import TranscriptUploader from '../../components/reusable/TranscriptUploader';
import {
  CloudArrowUpIcon,
  ShieldCheckIcon,
  BoltIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';
import { LoginForm } from '../login/LoginForm';
import { useAuth } from '../../hooks/useAuth';
import './transcript-upload.css';

export default function TranscriptUpload() {
  const { user, loading, error, getAuth } = useAuth();

  if (!user) {
    return (
      <LoginForm
        onSSOLogin={getAuth}
        ssoLoading={loading}
        ssoError={error}
      />
    );
  }

  return (
    <div className="upload-page">
      <div className="upload-content">
        <div className="upload-page-head">
          <div className="upload-page-head-icon">
            <CloudArrowUpIcon />
          </div>
          <div>
            <h1 className="upload-page-title">Upload transcript</h1>
            <p className="upload-page-sub">
              Upload a new audio, video or text file. The system will transcribe and
              process it automatically. You can attach event metadata from WordPress
              or FAICON, or create a custom entry.
            </p>
            <div className="upload-meta-row">
              <span className="upload-meta-chip">
                <BoltIcon />
                Auto‑transcription
              </span>
              <span className="upload-meta-chip">
                <SparklesIcon />
                Speaker diarization
              </span>
              <span className="upload-meta-chip">
                <ShieldCheckIcon />
                Secure upload
              </span>
            </div>
          </div>
        </div>

        <TranscriptUploader />
      </div>
    </div>
  );
}
